import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import StoreContext from "../Store/Context";
import { getApiUrl } from "../../utils/api";
import axios from "axios";

function initialState() {
  // return { user: "mauricioescobar@ifsul.edu.br", password: "1234" };
  return { user: "", password: "" };
}

async function login({ user, password }) {
  localStorage.setItem("token", JSON.stringify(""));

  await axios
    .post(getApiUrl("/auth/sign-in"), {
      email: user,
      password: password,
    })
    .then((response) => {
      if (response.data.metadata.token) {
        localStorage.setItem(
          "token",
          JSON.stringify(response.data.metadata.token)
        );
      }
    })
    .catch(function (error) {
      localStorage.setItem("token", JSON.stringify(""));
      console.debug("error calling api", error.toJSON());
    });
}

const Login = () => {
  const [values, setValues] = useState(initialState);
  const { setToken } = useContext(StoreContext);
  const history = useHistory();

  function onChange(event) {
    const { value, name } = event.target;

    setValues({
      ...values,
      [name]: value,
    });
  }

  const submitHandler = (e) => {
    e.preventDefault();

    login(values).then(() => {
      setToken(JSON.parse(localStorage.getItem("token")));
      return history.push("/management");
    });

    setValues(initialState);
  };

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Login</h2>
        </div>

        <div className="row mx-5 justify-content-center">
          <div className="col-md-4">
            <form onSubmit={submitHandler}>
              <div className="">
                <label>Nome de usuário (seu e-mail)</label>
                <input
                  type="text"
                  name="user"
                  onChange={onChange}
                  value={values.user}
                />
              </div>
              <div className="">
                <label>Senha</label>
                <input
                  type="password"
                  name="password"
                  onChange={onChange}
                  value={values.password}
                />
              </div>
              <div>
                <button className="button">Entrar</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
